module.exports = __webpack_public_path__ + "static/img/image006.979ca69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image006.png
// module id = LugN
// module chunks = 1